<template>
  <fade-transition>
    <aside
      v-if="!cookiesAccepted && showPopup"
      class="flex fixed pin-b pin-l z-50 px-6 py-4 bg-grey-900 text-white w-full items-center"
    >
      <div class="flex-1">
        <p>
          This website uses cookies to improve your experience. Please click to
          accept the terms of our
          <a href="/privacy-policy" target="_blank">Privacy Policy</a>.
        </p>
      </div>
      <div class="w-64 ml-6">
        <app-button
          type="button"
          class="focus:outline-none focus:shadow-outline"
          @click="acceptCookies"
        >
          Accept
        </app-button>
      </div>
    </aside>
  </fade-transition>
</template>

<script>
import { FadeTransition } from "vue2-transitions";
import parseISO from "date-fns/parseISO";
import differenceInDays from "date-fns/differenceInDays";
import formatISO from "date-fns/formatISO";

const APC_FUNDING_PORTAL_COOKIE_ACCEPTANCE =
  "APC_FUNDING_PORTAL_COOKIE_ACCEPTANCE";
export default {
  name: "AppCookies",
  components: { FadeTransition },
  data() {
    return {
      cookiesAccepted: false
    };
  },
  computed: {
    validCookieAcceptance() {
      const acceptance = window.localStorage.getItem(
        APC_FUNDING_PORTAL_COOKIE_ACCEPTANCE
      );
      if (!acceptance) return false;
      return differenceInDays(new Date(), parseISO(acceptance)) <= 7;
    },
    showPopup() {
      return window.location.pathname != "/coming-soon";
    }
  },
  created() {
    if (this.validCookieAcceptance) {
      this.cookiesAccepted = true;
    }
  },
  methods: {
    acceptCookies() {
      this.cookiesAccepted = true;
      window.localStorage.setItem(
        "APC_FUNDING_PORTAL_COOKIE_ACCEPTANCE",
        formatISO(new Date())
      );
    }
  }
};
</script>

<style></style>
